<template>
  <div style="display: flex !important; color: #0d6efd">
    <div style="cursor: pointer; font-size: 12px" :data-up-price-value="this.totalAmount"
      :data-up-price-type="priceType">
      <div style="display: flex !important; flex-wrap: wrap !important;justify-content: center;">
        <span class="me-1" style="color: grey; font-size: 12px">or </span>
        <div style="display:flex;">
          <span class="me-1" style="color: grey; font-size: 12px">from </span>
          <span style="font-size: 12px"> {{ this.paymentUplift?.currency }}</span>
          <span ref="upliftAmountSpan" data-up-from-currency-unit-major="" style="font-size: 12px"></span>
          <span style="font-size: 12px; color: grey">/mo</span>
          <span data-up-tooltip="" style="font-size: 12px; color: grey">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em"
              width="1em" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z">
              </path>
            </svg>
          </span>
        </div>
      </div>

    </div>

    <div id="up-pay-monthly-container"></div>
  </div>
  <div id="up-pay-monthly-selector"></div>
</template>

<script>
import { getConfigDataFromLocalStorage } from "@/localStorageData/localStorageUtil.js";
export default {
  props: {
    paymentUplift: {
      type: Object,
      required: true,
    },
    priceType: {
      type: String,
      required: true
    },
    isItinenary: {
      type: Boolean,
      required: true,
      default: false
    },
  },
  data() {
    return {
      totalAmount: "",
      reload: false,
      pointScale: "",
      currencyValue: "",
      upliftInitialized : false,
      someDataProperty: null,
      upliftConfig: {
        uplift_enabled: false,
        up_code: "",
        uplift_url: ""
      }
    };
  },

  methods: {
    getConfig() {
      const getConfigData1 = getConfigDataFromLocalStorage();
      if (getConfigData1) {
        // console.log(getConfigData1, "getConfigData1");
        // this.portalId = getConfigData1.payload.portal_configuration.portal_id;
        this.pointScale =
          getConfigData1.payload.portal_configuration.currency.iso_code;
        this.upliftConfig = {
          uplift_enabled: getConfigData1.payload.portal_configuration.uplift_payment.uplift_enabled || false,
          up_code: getConfigData1.payload.portal_configuration.uplift_payment.up_code || "",
          uplift_url: getConfigData1.payload.portal_configuration.uplift_payment.uplift_url || ""
        };
        // console.log(this.pointScale, "this.pointScale");
      }
    },

    loadUpliftScript() {
      if (!this.upliftConfig.uplift_enabled) {
        console.warn("Uplift is disabled in config");
        this.$emit("uplift-script-loaded", false);
        return;
      }

      const script = document.createElement("script");
      script.src = `${this.upliftConfig.uplift_url}?upcode=${this.upliftConfig.up_code}`;

      script.onload = () => {
        this.setupUpReady();

        let elapsed = 0;
        const interval = 250;
        const maxWait = 15000; // wait up to 3 seconds

        const checkInterval = setInterval(async () => {
          const amountSpan = document.querySelector('[data-up-from-currency-unit-major]');
          const text = amountSpan?.textContent?.trim();

          // console.log(text, this.paymentUplift.find1, 'this.paymentUplift.find1')
          if (amountSpan && text && !isNaN(Number(text.replace(/[^0-9.]/g, '')))) {
            clearInterval(checkInterval);
            // console.log(amountSpan, 'amountSpan')
            this.$emit("uplift-script-loaded", true, this.paymentUplift.selectId);
          } else {

            elapsed += interval;
            if (elapsed >= maxWait) {
              clearInterval(checkInterval);
              console.warn("Uplift amount not shown in UI after timeout");
              // console.log(amountSpan, 'amountSpan')
              this.$emit("uplift-script-loaded", false, this.paymentUplift.selectId);
            }
          }
        }, interval);
        // this.$emit("uplift-script-loaded", true);
      };

      script.onerror = () => {
        this.$emit("uplift-script-loaded", false);
        console.error("Failed to load Uplift script");
      };

      document.head.appendChild(script);
    },


    async initPayMonthly() {
      console.log("Initializing Uplift Payments...");
      window.Uplift?.Payments?.init({
        locale: `${this.updatevalue}-${this.paymentUplift?.pointofSale}`,
        currency: this.pointScale,
        checkout: false,
        channel: "desktop",
      });
    },
//     async setupUpReady() {

//       window.upReady = async () => {
//         console.log("Look, up.js snippet is executing me!!!");

//         await this.initPayMonthly();
//         var orderInfo = await this.buildOrderInfo();
//         await window.Uplift.Payments.load(orderInfo);
//         // window.Uplift.Payments.on("CHANGE", this.myOnChangeCallback);
//         window.console.log("The orderInfo object was created: ", orderInfo);
//         const upliftSpan = document.querySelector('[data-up-from-currency-unit-major]');
// console.log("Uplift Monthly Amount:", upliftSpan?.innerText);
//       };
//     },
async setupUpReady() {
  // const vm = this; // ✅ Capture Vue component context

  window.upReady = async () => {
    console.log("Look, up.js snippet is executing me!!!");

    await this.initPayMonthly();
    const orderInfo = await this.buildOrderInfo(); // ✅ now uses correct context
    await window.Uplift.Payments.load(orderInfo);
    console.log("The orderInfo object was created: ", orderInfo);
  }
},

    myOnChangeCallback(response) {
      const statusHandlers = {
        OFFER_AVAILABLE: () => {
          document.getElementById("up-offer-not-available").style.display = "block";
          document.getElementById("up-pay-monthly-selector-from-pricing").style.display = "none";
          // this.$emit("uplift-script-loaded", false);
        },
        TOKEN_AVAILABLE: () => {
          const token = window.Uplift?.Payments?.getToken?.();
          console.log(token, "Token Available");
        },
        TOKEN_RETRIEVED: () => {
          var token = response.token;
          console.log(token, "Token_retriver")
          if (response.token) {
            console.log("Token Retrieved:", response.token);
          } else {
            console.warn("No token found in response");
          }
        },
        OFFER_UNAVAILABLE: () => {
          console.log("Offer Unavailable");
          document.getElementById("up-offer-not-available").style.display = "none";
          document.getElementById("up-pay-monthly-selector-from-pricing").style.display = "block";
          this.$emit("uplift-script-loaded", false); // 👈 emit when offer unavailable
        },
        SERVICE_UNAVAILABLE: () => console.log("Service Unavailable"),
      };

      if (response?.status && statusHandlers[response.status]) {
        statusHandlers[response.status](); // 👈 call appropriate handler
      } else {
        console.warn("Unhandled Uplift status:", response?.status);
      }
    },
    multiReq(data) {
      let res = [];

      if (data?.Flight1?.length) {
        res.push({
          departure_apc: data.Flight1[0]?.Departure?.AirportCode,
          arrival_apc: data.Flight1[data.Flight1.length - 1]?.Arrival?.AirportCode,
          departure_time: data.Flight1[0]?.Departure?.Date?.replace(/-/g, '')
        });
      }

      if (data?.Flight2?.length) {
        res.push({
          departure_apc: data.Flight2[0]?.Departure?.AirportCode,
          arrival_apc: data.Flight2[data.Flight2.length - 1]?.Arrival?.AirportCode,
          departure_time: data.Flight2[0]?.Departure?.Date?.replace(/-/g, '')
        });
      }

      if (data?.Flight3?.length > 0) {
        res.push({
          departure_apc: data.Flight3[0]?.Departure?.AirportCode,
          arrival_apc: data.Flight3[data.Flight3.length - 1]?.Arrival?.AirportCode,
          departure_time: data.Flight3[0]?.Departure?.Date?.replace(/-/g, '')
        });
      }
      if (data?.Flight4?.length > 0) {
        res.push({
          departure_apc: data.Flight4[0]?.Departure?.AirportCode,
          arrival_apc: data.Flight4[data.Flight4.length - 1]?.Arrival?.AirportCode,
          departure_time: data.Flight4[0]?.Departure?.Date?.replace(/-/g, '')
        });
      }

      // console.log(res, "multicityuplift");
      return res;
    },


    async buildOrderInfo() {
      // console.log(this.paymentUplift,'paymentUplift')
      const isRoundTrip = this.paymentUplift.triptype.toLowerCase() === 'roundtrip';
      const ismulti = this.paymentUplift.triptype.toLowerCase() === 'multicity';
      const air_reservations = ismulti ?
        [
          {
            airline_name: this.paymentUplift?.Flight1[0]?.MarketingCarrier?.Name,
            origin: this.paymentUplift?.Flight1[0]?.Departure?.AirportCode,
            destination: this.paymentUplift?.Flight1[this.paymentUplift.Flight1.length - 1]?.Arrival?.AirportCode,
            trip_type: "open_jaw",
            itinerary: this.multiReq(this.paymentUplift),
            insurance: [],
          }
        ]
        :
        isRoundTrip ? [
          {
            airline_name: this.paymentUplift?.Depature[0]?.MarketingCarrier?.Name,
            origin: this.paymentUplift?.Depature[0]?.Departure?.AirportCode,
            destination: this.paymentUplift?.Depature[this.paymentUplift.Depature.length - 1]?.Arrival?.AirportCode,
            trip_type: this.paymentUplift.triptype.toLowerCase(),
            itinerary: [
              {
                departure_apc: this.paymentUplift?.Depature[0]?.Departure?.AirportCode,
                arrival_apc: this.paymentUplift?.Depature[this.paymentUplift.Depature.length - 1]?.Arrival?.AirportCode,
                departure_time: this.paymentUplift?.Depature[0]?.Departure?.Date.replace(/-/g, ''),
                arrival_time: this.paymentUplift?.Depature[this.paymentUplift.Depature.length - 1]?.Arrival?.Date.replace(/-/g, ''),
                fare_class: this.paymentUplift.cabinClass,
                carrier_code: this.paymentUplift?.Depature[0]?.MarketingCarrier?.AirlineID,
              },
              {
                departure_apc: this.paymentUplift?.Return[0]?.Departure?.AirportCode,
                arrival_apc: this.paymentUplift?.Return[this.paymentUplift.Return.length - 1]?.Arrival?.AirportCode,
                departure_time: this.paymentUplift?.Return[0]?.Departure?.Date.replace(/-/g, ''),
                arrival_time: this.paymentUplift?.Return[this.paymentUplift.Depature.length - 1]?.Arrival?.Date.replace(/-/g, ''),
                fare_class: this.paymentUplift.cabinClass,
                carrier_code: this.paymentUplift?.Return[0]?.MarketingCarrier?.AirlineID,
              }
            ],
            insurance: [],
          }
        ] :
          [
            {
              airline_name: this.paymentUplift?.Depature[0]?.MarketingCarrier?.Name,
              origin: this.paymentUplift?.Depature[0]?.Departure?.AirportCode,
              destination: this.paymentUplift?.Depature[this.paymentUplift.Depature.length - 1]?.Arrival?.AirportCode,
              trip_type: this.paymentUplift.triptype.toLowerCase(),
              itinerary: [
                {
                  departure_apc: this.paymentUplift?.Depature[0]?.Departure?.AirportCode,
                  departure_time: this.paymentUplift?.Depature[0]?.Departure?.Date.replace(/-/g, ''),
                  arrival_apc: this.paymentUplift?.Depature[this.paymentUplift.Depature.length - 1]?.Arrival?.AirportCode,
                  arrival_time: this.paymentUplift?.Depature[this.paymentUplift.Depature.length - 1]?.Arrival?.Date.replace(/-/g, ''),
                  fare_class: this.paymentUplift.cabinClass,
                  carrier_code: this.paymentUplift?.Depature[0]?.MarketingCarrier?.AirlineID,
                }
              ],
              insurance: [],
            }
          ];
      const orderInfo = {
        travelers: [],
        air_reservations,
        add_ons: [],
        order_amount: this.totalAmount
      };
      this.$emit("uplift-order-info-built", orderInfo);
      return orderInfo;
    },
  },

  created() {
    if (this.isItinenary) {
      this.totalAmount = parseInt(this.paymentUplift?.find1 * 100)
    } else {
      this.totalAmount = parseInt(this.paymentUplift?.TotalPrice * 100)
    }
    // console.log(this.paymentUplift?.TotalPrice, 'this.paymentUplift?.TotalPrice')
    this.getConfig()
  },

  watch: {
    async updatevalue(newVal) {
      this.upliftScriptReady = newVal;

      if (newVal === "en" || newVal === "fr") {

        this.$emit("uplift-script-loaded", true);
      } else {
        this.$emit("uplift-script-loaded", false);
      }

      this.initPayMonthly();
      const orderInfo = await this.buildOrderInfo();
      await window.Uplift.Payments.load(orderInfo);
    },
    totalAmount(newVal, oldVal) {
      if (newVal !== oldVal && window.Uplift?.Payments?.load) {
        // console.log("Rebuilding order info with updated totalAmount:", newVal);
        this.buildOrderInfo().then((orderInfo) => {
          window.Uplift.Payments.load(orderInfo);
        });
      }
    },
    paymentUplift: {
    immediate: true,
    handler(newVal) {
      // console.log("🔁 paymentUplift updated:", newVal);

      if (!newVal || typeof newVal !== 'object') return;

      if (this.isItinenary) {
        this.totalAmount = parseInt(newVal.find1 * 100);
      } else {
        this.totalAmount = parseInt(newVal.TotalPrice * 100);
        // console.log(this.totalAmount,"TotalAmount")
      }
       this.getConfig();
        this.setupUpReady();
        this.initPayMonthly()
      // Only initialize when data is ready
      if (this.upliftConfig.uplift_enabled && !this.upliftInitialized) {
        this.loadUpliftScript();
        this.setupUpReady();
        // this.initPayMonthly()
      }
    }
  },
  },
  computed: {
    updatevalue() {
      return this.$store.getters.getChangedLang
    },
  },

  mounted() {
    // console.log(this.paymentUplift, 'this.paymentUplift')
    // this.loadUpliftScript();
    // console.log("Uplift Monthly Amount:", this.$refs.upliftAmountSpan?.innerText);
    const upliftUrl = this.upliftConfig.uplift_url;
    const upliftCode = this.upliftConfig.up_code;
    if (this.upliftConfig.uplift_enabled) {
      (function (u, p, l, i, f, t, o, b, j) {
        u['UpLiftPlatformObject'] = f;
        u[f] = u[f] || function () { (u[f].q = u[f].q || []).push(arguments) };
        u[f].l = 1 * new Date();
        b = p.createElement(l), j = p.getElementsByTagName(l)[0];
        b.async = 1;
        b.src = i + '?upcode=' + t;
        j.parentNode.insertBefore(b, j);
        o = u.location.host.match(/[\w-]+\.\w{2,3}(:\d+)?$/);
        if (o) o = o[0];
        u[f]('create', t, o);
      })(window, document, 'script', upliftUrl, 'up', upliftCode);
      // this.loadUpliftScript();
      this.setupUpReady();
    }
  },
};
</script>
